<template>
  <div class="modal-column">
    <div class="modal-column-full-body">
      <Form ref="form" :model="form" :rules="{}" labelWidth="150">
        <div class="ml-20px font-bold mb-16px">基本信息</div>
        <div class="inline-form-item">
          <FormItem label="编号" prop="code" :required="required">
            <NumberInput type="text" v-model="form.code" :disabled="disabled"/>
          </FormItem>
          <FormItem label="姓名" prop="name" :required="required">
            <Input type="text" v-model="form.name"/>
          </FormItem>
          <FormItem label="性别" prop="gender" :required="required">
            <Select :deletable="false" v-model="form.gender" :datas="{1:'男', 2:'女'}"/>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="证件类型" prop="cardType" >
            <Select :deletable="false" v-model="form.cardType" :datas="{1:'居民身份证', 2:'中国护照', 3:'港澳居民来往内地通行证', 4:'台湾居民来往内地通行证', 5:'港澳居民居住证', 6:'台湾居民居住证', 7:'外国护照', 8:'外国人永久居留身份证'}"/>
          </FormItem>
          <FormItem label="证件号码" prop="idCard" >
            <Input type="text" v-model="form.idCard"/>
          </FormItem>
          <FormItem label="出生日期" prop="birthDate" :required="required">
            <DatePicker v-model="form.birthDate" :disabled="disabled"></DatePicker>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="手机" prop="telPhone" >
            <Input type="text" v-model="form.telPhone"/>
          </FormItem>
          <FormItem label="邮箱" prop="email">
            <Input type="text" v-model="form.email"/>
          </FormItem>
          <FormItem label="学历" prop="education" :required="required">
            <Select :deletable="false" v-model="form.education" :datas="educationDict1"/>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="银行名称" prop="bank">
            <Input type="text" v-model="form.bank"/>
          </FormItem>
          <FormItem label="银行卡号" prop="bankCard">
            <Input type="text" v-model="form.bankCard"/>
          </FormItem>
          <FormItem label="入职日期" prop="onBoardingDate" :required="required">
            <DatePicker v-model="form.onBoardingDate" :disabled="disabled"></DatePicker>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="部门" prop="departmentId" :required="required">
            <!-- 弹出新增部门 -->
            <div style="display:flex;flex-direction:row;align-items:center;">
              <Select :datas="deptList" filterable v-model="form.departmentId" :disabled="disabled"/>
              <Button icon="fa fa-plus" @click="openDept"></Button>
            </div>
          </FormItem>
          <FormItem label="岗位" prop="post">
            <Input type="text" v-model="form.post"/>
          </FormItem>
          <FormItem label="工资始发日期" prop="salaryStartDate" :required="required">
            <DatePicker v-model="form.salaryStartDate" :disabled="disabled"></DatePicker>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="职称" prop="professional">
            <Input type="text" v-model="form.professional"/>
          </FormItem>
          <FormItem label="基本工资" prop="baseSalary">
            <Input type="text" v-model="form.baseSalary"/>
          </FormItem>
<!--          <FormItem label="计提工资科目" prop="salaryAccount" :required="required">
            <Select :deletable="false" :disabled="disabled" :datas="subjectList" keyName="code"
                    titleName="fullName" filterable v-model="form.salaryAccount" :filter="filter">
              <template v-slot:item="{ item }">
                {{ item.code }} {{ item.fullName }}
              </template>
            </Select>
          </FormItem>-->
          <FormItem label="员工状态" prop="status" :required="required">
            <Select :deletable="false" v-model="form.status" :datas="{1:'在职', 2:'离职'}"/>
          </FormItem>
        </div>
        <div class="inline-form-item" v-if="form.status==2">
          <FormItem label="离职日期" prop="dimissionDate" :required="required">
            <DatePicker v-model="form.dimissionDate" :disabled="disabled"></DatePicker>
          </FormItem>
          <FormItem label="工资停发日期" prop="salaryEndDate" :required="required">
            <DatePicker v-model="form.salaryEndDate" :disabled="disabled"></DatePicker>
          </FormItem>
        </div>
        <div class="inline-form-item">
          <FormItem label="备注" prop="remark">
            <Textarea v-model="form.remark" rows="2"></Textarea>
          </FormItem>
        </div>

        <div class="line"></div>

        <div class="ml-20px font-bold mb-16px">扣除款项</div>
        <div class="inline-form-item">
          <FormItem label="是否缴纳五险一金" prop="enableSocial"  :required="required">
            <Radio v-model="form.enableSocial" @change="socialListChange" dict="defaultRadios"/>
          </FormItem>
<!--          <FormItem label="五险一金设置" prop="insureId" :required="required">
            <Select @change="changeInsure" :datas="insureList" filterable v-model="form.insureId" :disabled="disabled"/>
          </FormItem>-->
        </div>
        <div v-if="form.enableSocial">
          <vxe-table
                  ref="itemsTable"
                  :data="form.socialDataList"
                  border
                  :edit-config="{trigger:'click', mode:'cell', showIcon: false}"
                  @edit-closed="saveChange"
                  style="height: 265px"
                  height="auto"
                  align="center">
            <vxe-column field="name" title="缴纳项目"/>
            <vxe-column field="depositBase" title="缴存基数" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row }">
                <vxe-input min="1" v-model="row.depositBase" @change="depositBaseChange(row)" type="number"></vxe-input>
              </template>
            </vxe-column>
            <!-- 常规修正补足 -->
            <vxe-colgroup title="公司承担部分">
              <vxe-column field="enterprise" title="公司缴纳比例(%)" :edit-render="{name:'$input'}">
                <template #edit="{ row }">
                  <vxe-input v-model="row.enterprise" @change="calculateAmounts(row, 'enterprise')" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column field="enterpriseAmount" title="公司缴纳金额" />
            </vxe-colgroup>
            <vxe-colgroup title="个人承担部分">
              <vxe-column field="personal" title="个人缴纳比例(%)" :edit-render="{name:'$input'}">
                <template #edit="{ row }">
                  <vxe-input v-model="row.personal" @change="calculateAmounts(row, 'personal')" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column field="personalAmount" title="个人缴纳金额" />
            </vxe-colgroup>
          </vxe-table>
        </div>
      </Form>
    </div>
    <div class="modal-column-between">
      <Button @click="$emit('close')">取消</Button>
      <div>
        <Button color="primary" @click="submit(false)" :loading="loading">{{ this.id ? '更新' : '保存' }}</Button>
        <Button v-if="!this.id" color="primary" @click="submit(true)" :loading="loading">保存并新增</Button>
      </div>
    </div>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Employee from "@/api/Employee";
import InsuredConfig from "@/api/InsuredConfig";
import {CopyObj} from "@/js/common/utils";
import {mapState} from "vuex";
import setting from "@/api/setting";
import Setting from "@/api/setting";
import HeyUI from "heyui.ext";
import {heyuiConfig} from "heyui.ext";
//新增部门
import {layer} from "@layui/layer-vue";
import DepartmentForm from "@/views/setting/AssistingAccounting/form/DepartmentForm.vue";
import {ref, defineProps, h} from "vue";

export default {
  name: "EmployeeForm",
  props: {
    entity: Object,
    id: Object
  },
  data() {
    return {
      loading: false,
      deptList: [],
      insureList: [],
      subjectList: [],
      required:true,
      form: {
        id: null,
        code: null,
        name: null,
        gender: 1,
        cardType: 1,
        idCard: null,
        birthDate: null,
        telPhone: null,
        email: null,
        education: 1,
        bank: null,
        bankCard: null,
        dimissionDate: null,
        onBoardingDate: null,
        departmentId: null,
        post: null,
        salaryStartDate: null,
        salaryEndDate: null,
        professional: null,
        salaryAccount: null,
        baseSalary: "",
        status: 1,
        remark: null,
        enableSocial: false,
        socialDataList: [],


      },
    }
  },
  computed: {
    educationDict1() {
      let dict = heyuiConfig.getDict('educationDict');
      return dict;
    },
    ...mapState(['currentAccountSets']),

  },
  watch: {
    required() {
      this.$refs.form.resetValid();
    }
  },
  methods: {
    // 常规修正补足
    calculateAmounts(row, type) {
      // 检查depositBase和比例是否为有效的数字
      const isValidDepositBase = !isNaN(parseFloat(row.depositBase)) && isFinite(row.depositBase);
      const isValidRatio = type === 'enterprise' 
        ? (!isNaN(parseFloat(row.enterprise)) && isFinite(row.enterprise)) 
        : (!isNaN(parseFloat(row.personal)) && isFinite(row.personal));

      if (isValidDepositBase && isValidRatio) {
        if (type === 'enterprise') {
          row.enterpriseAmount = (row.depositBase * row.enterprise / 100).toFixed(2);
        } else if (type === 'personal') {
          row.personalAmount = (row.depositBase * row.personal / 100).toFixed(2);
        }
      } else {
        if (type === 'enterprise') {
          row.enterpriseAmount = ''; // 或者可以设置为null或其他标识无效的值
        } else if (type === 'personal') {
          row.personalAmount = ''; // 或者可以设置为null或其他标识无效的值
        }
      }
    },
    //新增部门
    openDept (entity){
      let layerId = layer.open({
        title: "部门信息",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['700px', 'auto'],
        content: h(DepartmentForm, {
          entity,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.initSelect();
          }
        })
      });
    },
    loadList() {
      if (!this.id) {
        InsuredConfig.list().then((res) => {
          this.form.socialDataList = res.data.map(item=>{return {...item,insureDetailId:item.id,id:null}})
        })
      } else {
        //初始化参数
        Employee.queryEmployeeDetail(this.id).then(res=>{
          // console.log("详情啊",res.data)
          this.form = {...res.data,socialDataList:res.data.socialList}
        })
      }
    },
    socialListChange(radio) {
      // console.log("ffffffff",val)
      // console.log("aaaaaa",val.key)
      if (radio.key) {
        //启用五险一金
        if (!this.form.socialDataList || this.form.socialDataList.length===0) {
          InsuredConfig.list().then((res) => {
            this.form.socialDataList = res.data.map(item=>{return {...item,insureDetailId:item.id,id:null}})
          })
        }
      }
    },
    depositBaseChange(row) {
      // console.log("row",row)
      if (!row.depositBase) {
        row.enterpriseAmount = '';
        row.personalAmount = '';
      }else {

        row.enterpriseAmount = (Number(row.depositBase) * (Number(row.enterprise)/100)).toFixed(2);

        row.personalAmount = (Number(row.depositBase) * (Number(row.personal)/100)).toFixed(2);
      }
    },
    submit(add = false) {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      //日期逻辑判断
      if (this.form.salaryStartDate<this.form.onBoardingDate) {
        this.$Message['error']("工资始发日期不能早于入职日期")
        return;
      }
      // console.log("form",this.form)
      if (this.form.status==2) {
        if (!this.form.dimissionDate) {
          this.$Message['error']("请选择离职日期")
          return;
        }
        if (!this.form.salaryEndDate) {
          this.$Message['error']("请选择工资停发日期")
          return;
          return;
        }
        if (this.form.dimissionDate<this.form.onBoardingDate) {
          this.$Message['error']("离职日期不能早于入职日期")
          return;
        }
      }
      this.loading = true;
      if (!this.form.enableSocial) {
        this.form.socialDataList = []
      }
      if (!this.id) {
        Employee.save(this.form).then(() => {
          if(add){
            this.$Message['success']("保存成功~")
            this.form.id = null;
            this.form.code = null;
            this.form.name = null;
            this.form.gender = 1;
            this.form.cardType = 1;
            this.form.idCard = null;
            this.form.birthDate = null;
            this.form.telPhone = null;
            this.form.email = null;
            this.form.education = 1;
            this.form.bank = null;
            this.form.bankCard = null;
            this.form.dimissionDate = null;
            this.form.onBoardingDate = null;
            this.form.departmentId = null;
            this.form.post = null;
            this.form.salaryStartDate = null;
            this.form.salaryEndDate = null;
            this.form.professional = null;
            this.form.salaryAccount = null;
            this.form.baseSalary = "";
            this.form.status = 1;
            this.form.remark = null;
            this.form.enableSocial = false;
            this.form.socialDataList = [];
          }else{
            this.$Message['success']("保存成功~")
            this.$emit('success');
          }
        }).finally(() => {
          this.loading = false;
        });
      }else {
        Employee.update(this.form).then(() => {
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        });
      }

    },
    initSelect() {
      //初始化部门
      setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
        this.deptList = data['DEPARTMENT'].map(val => {
          return {
            key: val.id,
            accountingCategoryId: val.categoryId,
            title: val.name
          }
        });
      })
    },

    // 编辑数据接口
    saveChange({ row, column }) {
      // const field = column.field
      // const cellValue = row[field]
      // if ((row['projectName'] === '工伤保险' || row['projectName'] === '生育保险') && (field === 'individualPayment' || field === 'individualMoney')) {
      //   row[field] = ''
      //   return false
      // }
    },
    changeInsure(data) {
      // InsuredConfig.queryInsureProject(data.key).then((result) => {
      //   this.insureList = result
      // })
    }
  },
  created() {
    this.loadList()
    this.initSelect()
  }
}
</script>

<style lang="less" scoped>
  .line {
    height: 1px;
    background-color: #dadada;
    margin: 20px 0;
  }
</style>
